import React from 'react'
import Movies from './Movies'
import Search from './Search'

const Home = () => {
  return (
    <div>
    <Search/>
    <Movies/>
    </div>
  )
}

export default Home